import { render } from "./WorkIllust.vue?vue&type=template&id=ae4d1b28&scoped=true"
import script from "./WorkIllust.vue?vue&type=script&lang=js"
export * from "./WorkIllust.vue?vue&type=script&lang=js"

import "./WorkIllust.vue?vue&type=style&index=0&id=ae4d1b28&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae4d1b28"]])

export default __exports__